import { styled } from '@mui/material';

export const CategoryChip = styled('span')({
  color: 'rgba(0,0,0, 0.87)',
  fontWeight: 400,
  padding: '8px 12px',
  borderRadius: 4,
});
